import queryString from 'query-string';
import { call, select } from 'redux-saga/effects';
import { ALLOWED_PROP_TYPES } from './constants';
import { getServerConfig } from './selectors';
import { API } from '../../../api';

export function* fetchParcelRelatedRecords(src, parcelId, config) {
  if (!parcelId) return null;
  let sort = 'date';
  let filterString = '';
  let finalSource = src;

  const props = config.report.sections.reduce((acc, section) => {
    if (!section && !section.properties) return acc;
    const columns = section.properties
      .filter(
        ({ type, endpoint, input }) => ALLOWED_PROP_TYPES.includes(type) &&
          endpoint === finalSource &&
          input == null,
      )
      .map(({
        column, source, sortBy, filter,
      }) => {
        if (sortBy) sort = sortBy;
        if (filter) filterString = filter;
        finalSource = source;
        return column;
      });
    return acc.concat(columns);
  }, []);

  if (!props.length) return null;

  const serverConfig = yield select(getServerConfig);
  const query = {
    props: props.join(','),
    sort,
    source: finalSource,
  };

  if (config.report.source) query.source = config.report.source;

  const path = `/${finalSource}/${serverConfig.namespace
    }/${parcelId}?${queryString.stringify(query)}${filterString ? `&${filterString}` : ''
    }`;
  const results = yield call(API, 'get', 'api', path);

  if (results && results.data && results.data.length) {
    const data = results.data.map(sale => Object.entries(sale).reduce((acc, [key, value]) => {
      acc[`${finalSource}:${key}`] = value;
      return acc;
    }, {}));

    return {
      [src]: data,
    };
  }

  return null;
}
